import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import Collapse from "react-bootstrap/Collapse";
import Select from "react-select";
import ProductServices from "../../../services/ProductServices";
import LocationServices from "../../../services/LocationServices";
import UpdateInventory from "./UpdateInventory";
import * as XLSX from "xlsx";
import Pagination from "../Pagenation/Pagenation";
import { Button } from "react-bootstrap";
import Loader from "../Loader/loader";

const InventoryList = () => {
  const [open, setOpen] = useState(true);
  const [open2, setOpen2] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);


  // Retrieve logged-in user.
  const [user] = useState(() => {
    try {
      return (
        JSON.parse(localStorage.getItem("userDetails") || "null") || {
          data: {
            user: {
              role: "",
              store: []
            }
          }
        }
      );
    } catch {
      return {
        data: {
          user: {
            role: "",
            store: []
          }
        }
      };
    }
  });

  const currentRole = String(user?.data?.user?.role || "")
    .trim()
    .toLowerCase();

  const canViewAllStores = [
    "director",
    "superadmin",
    "auditor"
  ].includes(currentRole);

  const availableStores = Array.isArray(user?.data?.user?.store)
    ? user.data.user.store.filter((store) => store?._id)
    : [];

  const [stores, setStores] = useState(
    canViewAllStores ? [] : availableStores
  );

  const [selectedStore, setSelectedStore] = useState(
    canViewAllStores ? "" : availableStores[0]?._id || ""
  );

  const [storesLoading, setStoresLoading] = useState(false);
  const [storeLoadError, setStoreLoadError] = useState("");

  useEffect(() => {
    if (!canViewAllStores) return;

    let cancelled = false;

    const loadStores = async () => {
      setStoresLoading(true);
      setStoreLoadError("");

      try {
        const response = await LocationServices.getStore();
        const storeList = response?.data?.data;

        if (!Array.isArray(storeList)) {
          throw new Error("Unexpected store API response.");
        }

        const validStores = storeList.filter((store) => store?._id);

        if (!cancelled) {
          setStores(validStores);

          setSelectedStore((previous) =>
            validStores.some(
              (store) => String(store._id) === String(previous)
            )
              ? previous
              : validStores[0]?._id || ""
          );
        }
      } catch (error) {
        if (!cancelled) {
          setStores([]);
          setSelectedStore("");
          setStoreLoadError(
            error?.response?.data?.message ||
            error?.message ||
            "Unable to load stores."
          );
        }
      } finally {
        if (!cancelled) {
          setStoresLoading(false);
        }
      }
    };

    loadStores();

    return () => {
      cancelled = true;
    };
  }, [canViewAllStores]);
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [sort, setsort] = useState(150); // Number of items per page
  const activePag = useRef(0);
  const [test, setTest] = useState(0);
  const [selectedItem, setSelectedItem] = useState({})
  const [isModelOpen, setIsModelOpen] = useState()
  const [run, setRun] = useState(0)

  // Display row options
  const options = [
    { value: 5, label: "5" },
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  // Fetch inventory for the selected store.
  useEffect(() => {
    let cancelled = false;

    // Clear the previous store's inventory.
    setData([]);
    setError(null);

    if (!selectedStore) {
      setLoading(false);
      return;
    }

    const fetchInventory = async () => {
      setLoading(true);

      try {
        const response = await ProductServices.getInventory(
          selectedStore
        );

        const allData = response?.data?.data;

        if (!Array.isArray(allData)) {
          throw new Error("Unexpected inventory API response.");
        }

        const storeFilteredData = allData.filter((item) => {
          const storeId = item?.store?._id || item?.store;

          return String(storeId || "") === String(selectedStore);
        });

        // Ignore old responses when the selected store changes.
        if (!cancelled) {
          setData(storeFilteredData);
        }
      } catch (error) {
        if (!cancelled) {
          setData([]);
          setError(
            error?.response?.data?.message ||
            error?.message ||
            "Unable to fetch inventory."
          );
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchInventory();

    return () => {
      cancelled = true;
    };
  }, [selectedStore, run]);

  // Handle search.
  useEffect(() => {
    const query = searchTerm.trim().toLowerCase();

    const filtered = query
      ? data.filter((item) =>
        [
          item?.masterItem?.partNo,
          item?.masterItem?.description,
          item?.masterItem?.category?.name
        ].some((value) =>
          String(value ?? "").toLowerCase().includes(query)
        )
      )
      : data;

    setFilteredData(filtered);

    activePag.current = 0;
    setTest((previous) => previous + 1);
  }, [searchTerm, data]);

  // Pagination setup.
  const pagination = Math.ceil(filteredData.length / sort);

  const currentData = filteredData.slice(
    activePag.current * sort,
    (activePag.current + 1) * sort
  );

  const onClick = (page) => {
    activePag.current = page;
    setTest((previous) => previous + 1);
  };

  const handleSelectChange = (selectedOption) => {
    if (!selectedOption) return;

    setsort(selectedOption.value);
    activePag.current = 0;
    setTest((previous) => previous + 1);
  };

  const handleStoreChange = (event) => {
    setSelectedStore(event.target.value);
    setSearchTerm("");
    setData([]);
    setFilteredData([]);
    setError(null);

    activePag.current = 0;
    setTest((previous) => previous + 1);
  };

  const Persentage = (user) => {
    const auth = Number(user?.qtyAuth) || 0;
    const totalRecive = Number(user?.totalRecive) || 0;
    const transfer = Number(user?.transfer) || 0;

    if (auth === 0) return 0;

    const percentage = ((totalRecive - transfer) / auth) * 100;

    return Number.isFinite(percentage)
      ? percentage.toFixed(2)
      : 0;
  };

  const handleEditClick = (item) => {
    setSelectedItem(item);
    setIsModelOpen(true);
  };

  const downloadExcel = () => {
    if (filteredData.length === 0) {
      alert("No data available to download.");
      return;
    }

    const excelData = filteredData.map((item, index) => ({
      "#": index + 1,
      "Part No.": item?.masterItem?.partNo ?? "N/A",
      "Description": item?.masterItem?.description || "N/A",
      "Authorized": item?.qtyAuth || 0,
      "unit": item?.masterItem?.unit?.name || "N/A",
      "Received": item?.totalRecive || 0,
      "Transferred": item?.transfer || 0,
      "MIV": item?.totalMiv || 0,
      "Transition Qty": item?.transitionQty || 0,
      "Critical Status":
        item?.currentStock <= item?.criticalStockQty
          ? `${item?.criticalStockQty} | Low`
          : item?.criticalStockQty || 0,
      "Current Stock": item?.currentStock || 0,
      "Damage": item?.damage || 0,
      "%": `${Persentage(item)}%`
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Table Data"
    );

    XLSX.writeFile(workbook, "Inventory.xlsx");
  };

  function handleAmount(currentStock, rate) {
    const stock = Number(currentStock) || 0;
    const itemRate = Number(rate) || 0;

    return (stock * itemRate).toFixed(2);
  }

  const handleCriticalToggle = async (item) => {
    try {
      const updatedValue = !item.critical;

      await ProductServices.UpdateInventory(item._id, {
        critical: updatedValue
      });

      setRun((previous) => previous + 1);
    } catch (error) {
      console.error("Error updating inventory:", error);
    }
  };

  const cleanStock = (value) => {
    const number = Number(value);

    return Number.isFinite(number)
      ? Number(number.toFixed(2))
      : 0;
  };

  const checkScrollEnd = (container) => {
    const scrollLeft = container.scrollLeft;
    const maxScroll =
      container.scrollWidth - container.clientWidth;

    const atStart = scrollLeft <= 5;
    const atEnd = scrollLeft >= maxScroll - 5;

    setShowLeft(!atStart);
    setShowRight(!atEnd);
    setIsAtEnd(atEnd);
  };

  useEffect(() => {
    const container = document.getElementById("inventoryTable");

    if (!container) return;

    checkScrollEnd(container);

    const handleScroll = () => checkScrollEnd(container);

    container.addEventListener("scroll", handleScroll);

    return () => {
      container.removeEventListener("scroll", handleScroll);
    };
  }, [filteredData]);

  const scrollTable = (direction) => {
    const container = document.getElementById("inventoryTable");

    if (!container) return;

    container.scrollBy({
      left: direction === "right" ? 300 : -300,
      behavior: "smooth"
    });
  };

  return (
    <>
      <UpdateInventory
        item={selectedItem}
        show={isModelOpen}
        handleClose={() => setIsModelOpen(false)}
        store={stores}
        onSuccess={() => setRun(prev => prev + 1)}
      />
      <div className="row">
        {loading ? (
          <Loader />
        ) : (
          <div className="col-xl-12">
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fas fa-filter me-2"></i>Filter
                </div>
                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
                    onClick={() => setOpen(!open)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="row">

                      <div className="col-xl-4 col-xxl-4">
                        <label className="form-label ms-2">Search Inventory</label>
                        <input
                          type="text"
                          className="form-control mb-xl-0 mb-3"
                          id="searchInput"
                          placeholder="Search by Part No.or Description"
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                      <div className="col-xl-4 col-xxl-4">
                        <label
                          htmlFor="inventory-store"
                          className="form-label ms-2"
                        >
                          Select Store
                        </label>

                        <select
                          id="inventory-store"
                          className="form-select mb-xl-0 mb-3 pt-3 pb-3"
                          value={selectedStore}
                          onChange={handleStoreChange}
                          disabled={storesLoading}
                        >
                          <option value="" disabled>
                            {storesLoading ? "Loading Stores..." : "Select Store"}
                          </option>

                          {stores.map((store) => (
                            <option key={store._id} value={store._id}>
                              {[store.name, store.location]
                                .filter(Boolean)
                                .join(" / ")}
                            </option>
                          ))}
                        </select>

                        {storeLoadError && (
                          <div className="text-danger mt-2" role="alert">
                            {storeLoadError}
                          </div>
                        )}
                      </div>

                      <div className="col-xl-4 col-xxl-4">
                        <label className="form-label ms-2">Select Display Rows</label>
                        <Select

                          placeholder="Select Display Rows"
                          value={options.find((option) => option.value === sort)}
                          onChange={handleSelectChange}
                          isSearchable={false}
                          options={options}
                          className="custom-react-select mb-3 mb-xxl-0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
            <div className="filter cm-content-box box-primary">
              <div className={`content-title`}>
                <div className="cpa">
                  <i className="fa fa-list me-2" aria-hidden="true"></i>Inventory List<span className="badge bg-orange ms-2">{filteredData.length}</span>
                </div>
                <div className="tools">
                  <Link
                    to={"#"}
                    className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`}
                    onClick={() => setOpen2(!open2)}
                  >
                    <i className="fas fa-angle-up"></i>
                  </Link>
                </div>
              </div>
              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <div className="table-responsive">
                      <div
                        id="content_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        {["superadmin", "auditor"].includes(
                          String(user?.data?.user?.role || "").trim().toLowerCase()
                        ) && (
                            <div className="d-flex justify-content-end me-3 mb-2">
                              <Button
                                variant="success"
                                size="sm"
                                onClick={downloadExcel}
                                className="p-2"
                              >
                                <i
                                  className="fas fa-file-excel me-1"
                                  aria-hidden="true"
                                />
                                Download Excel
                              </Button>
                            </div>
                          )}

                        <div className="table-scroll-container">

                          {showLeft && (
                            <div
                              className="table-arrow left"
                              onClick={() => scrollTable("left")}
                            >
                              <i className="fas fa-chevron-left"></i>
                            </div>
                          )}

                          {showRight && (
                            <div
                              className="table-arrow right"
                              onClick={() => scrollTable("right")}
                            >
                              <i
                                className={`fas ${isAtEnd
                                  ? "fa-chevron-left"
                                  : "fa-chevron-right"
                                  }`}
                              ></i>
                            </div>
                          )}

                          <div
                            id="inventoryTable"
                            className="scrolltable"
                          >
                            <table
                              className="table table-bordered table-responsive-lg table-striped table-condensed flip-content"
                              id="transactions-data"
                            >
                              <thead
                                className="sticky-table-header"
                              >
                                <tr>
                                  <th>#</th>
                                  <th>Part No.</th>
                                  <th>Image</th>
                                  <th>Description</th>
                                  <th>Unit</th>
                                  <th>Authorized</th>
                                  <th>Received</th>
                                  <th>Transfered</th>
                                  <th>Transition Qty</th>
                                  <th>Repair Qty</th>
                                  <th>MIV</th>

                                  <th>Current
                                    <br />Stock</th>
                                  <th>Damage</th>
                                  <th>%</th>
                                  <th>Rate</th>
                                  <th>Amount</th>
                                  <th>Critical
                                    <br /> Status</th>
                                  <th>Critical</th>
                                  {user.data.user.role === 'superAdmin' && (
                                    <th>Action</th>
                                  )}
                                </tr>
                              </thead>
                              <tbody>
                                {Array.isArray(currentData) && currentData.length > 0 ? (
                                  currentData.map((item, index) => (
                                    <tr key={index}>
                                      <td>{activePag.current * sort + index + 1}</td>
                                      <td>{item?.masterItem?.partNo}</td>
                                      <td>
                                        {item?.masterItem?.image ? (
                                          <img
                                            src={`https://indigoinfra.in/img/product/${item?.masterItem?.image}`}
                                            alt={item?.masterItem?.partNo}
                                            className="thumbnail-image"
                                          />
                                        ) : (
                                          "No image"
                                        )}
                                      </td>
                                      <td className="scrollable-description">{item?.masterItem?.description}</td>
                                      <td>{item?.masterItem?.unit?.name}</td>

                                      <td>{item?.qtyAuth}</td>

                                      <td>{Number.isInteger(item?.totalRecive) ? item?.totalRecive : item?.totalRecive.toFixed(2)}</td>

                                      <td>{item?.transfer}</td>
                                      <td>{cleanStock(item?.transitionQty)}</td>
                                      <td>{item?.repairQty || 0}</td>
                                      <td>{item?.totalMiv}</td>
                                      <td>{cleanStock(item?.currentStock)}</td>
                                      <td>{item?.damage || 0}</td>
                                      <td>{Persentage(item)}%</td>
                                      <td>{item?.masterItem?.rate || 0}</td>
                                      <td>{handleAmount(item?.currentStock, item?.masterItem?.rate)}</td>
                                      <td className="scrollable-description">{item?.currentStock <= item?.criticalStockQty ? `${item?.criticalStockQty} | Low` : item?.criticalStockQty}</td>

                                      <td className="text-center">
                                        <input
                                          type="checkbox"
                                          checked={item.critical === true}
                                          onChange={() => handleCriticalToggle(item)}
                                        />
                                      </td>

                                      {user.data.user.role === 'superAdmin' && (

                                        <td>
                                          <button
                                            className="btn btn-primary btn-xs sharp"
                                            onClick={() => handleEditClick(item)} // Open modal on edit click
                                          >
                                            <i className="fa fa-pencil"></i>
                                          </button>
                                        </td>
                                      )}
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan="12">No data available</td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                          <div className="dataTables_info">
                            Showing{" "}
                            {filteredData.length === 0 ? 0 : activePag.current * sort + 1}
                            {" "}to{" "}
                            {Math.min(
                              filteredData.length,
                              (activePag.current + 1) * sort
                            )}
                            {" "}of {filteredData.length} entries
                          </div>
                          <Pagination
                            activePage={activePag.current}
                            totalPages={pagination}
                            onPageChange={onClick}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapse>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default InventoryList;
